/*jshint esversion: 6 */

import $ from 'jquery';

let $items = [];

const SELECTORS = {
  ACCORDION: '.accordion',
  ITEM: '.accordion__item',
  ITEM_HEADER: '.accordion__item__header',
  ITEM_HEADER_BTN: '.accordion__item__header__btn',
  ITEM_OPEN: 'accordion__item--open'
};

function init() {
  $(SELECTORS.ACCORDION).each((index, element) => {
    let $accordion = $(element);
    initAccordion($accordion);
  });
}

function initAccordion($accordion) {
  $items = [];
  $accordion.find(SELECTORS.ITEM).each((index, element) => {
    const $item = $(element);
    $items.push($item);
    initAccordionItem($item);
  });

  if ($items.length === 1) {
    openItem($items[0]);
  }
}

function initAccordionItem($item) {
  let $header = $item.find(SELECTORS.ITEM_HEADER);
  $header.on('click', event => {
    event.preventDefault();
    if ($item.hasClass(SELECTORS.ITEM_OPEN)) {
      closeItem($item);
    } else {
      openItem($item);
    }
  });
}

function openItem($item) {
  $item.addClass(SELECTORS.ITEM_OPEN);
  $item.find(SELECTORS.ITEM_HEADER_BTN).attr('aria-expanded', true);
  $item.trigger('accordionItemOpened');

  closeOtherItems($item, $items);
}

function closeItem($item, silent) {
  $item.removeClass(SELECTORS.ITEM_OPEN);
  $item.find(SELECTORS.ITEM_HEADER_BTN).attr('aria-expanded', false);

  if (!silent) {
    $item.trigger('accordionItemClosed');
  }
}

function closeOtherItems($openItem) {
  for (const $item of $items) {
    if ($item.is($openItem)) continue;
    closeItem($item, true);
  }
}

export default init;

